export default "__VITE_ASSET__Bi7tbcDS__"